import styled from 'styled-components/macro'

import { getToken, toCSSValue } from '@loadsmart/miranda-react/dist/tokens'

import { hasPuDelCoordinates } from 'core/domain/Load'
import { Map } from 'core/ui/components/map/Map'
import { DEFAULT_MARKER_ICON, grayishMapStyles } from 'core/ui/components/map/Map.styles'
import { useGoogleMaps } from 'core/ui/hooks/useGoogleMaps'

import { screen } from 'legacy/styles/screen'

import { type Load } from '../domain/Load'
import { getCoordinatesFromStops } from '../presenter/tenderPresenter'

const DEFAULT_PRIMARY_ROUTE_COLOR = `rgba(${getToken('color-success-60')}, 1)`

const MapWrapper = styled.div`
  border-radius: ${getToken('border-radius-s')};
  border: ${getToken('border-thin')} solid ${toCSSValue('color-border')};
  width: 30%;
  display: none;
  ${screen.lg} {
    display: unset;
  }
`

const mapContainerStyle = {
  display: 'flex',
  height: '100%',
  borderRadius: '6px',
}

export type LoadDetailProps = {
  load: Load
}

export function LoadMap({ load }: LoadDetailProps) {
  const { isLoaded } = useGoogleMaps()

  const hasCoordinates = hasPuDelCoordinates(load)

  if (!isLoaded || !hasCoordinates) return null

  const { puCoordinate, delCoordinate } = getCoordinatesFromStops(load)

  return (
    <MapWrapper>
      <Map
        markers={[
          { icon: { url: DEFAULT_MARKER_ICON }, coordinate: puCoordinate },
          { icon: { url: DEFAULT_MARKER_ICON }, coordinate: delCoordinate },
        ]}
        coordinates={[puCoordinate, delCoordinate]}
        mapContainerStyle={mapContainerStyle}
        mapStyle={grayishMapStyles}
        primaryRouteColor={DEFAULT_PRIMARY_ROUTE_COLOR}
      />
    </MapWrapper>
  )
}
